<template>
  <a-modal v-model="visible" title="打印" @ok="handleOk" @cancel="handleCancel" :footer="false">
    <div style="height: 265px; background: #e3e3e3; color: black">
      <div style="height: 10px"></div>
      <div class="print-shezhi">
        <div>设置默认打印机</div>
        <div>
          <select class="print-select">
            <option>Brother MFC-86530DVPrinter</option>
            <option>Brother MFC-86530DVPrinter副本</option>
          </select>
        </div>
      </div>
      <div class="print-kuang"></div>
      <div class="print-xuanfu">
        <div>边距调整</div>
        <div class="print-tiaozheng-flex">
          <div>向下调整：</div>
          <div>
            <input />
          </div>
          <div>毫米</div>
        </div>
        <div class="print-tiaozheng-flex" style="margin-top: 15px">
          <div>右调整：</div>
          <div>
            <input />
          </div>
          <div>毫米</div>
        </div>
      </div>
      <div class="print-tiaozhen"></div>
      <div class="print-button">
        <a-button type="primary" class="print-button-child" size="small" style="margin-right: 20px">预览</a-button>
        <a-button type="primary" class="print-button-child" size="small" @click="printFp" style="margin-right: 20px"
          >打印</a-button
        >
        <a-button
          type="primary"
          class="print-button-child"
          size="small"
          @click="cancelFPrintFp"
          style="margin-right: 20px"
          >不打印</a-button
        >
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      // this.close()
      this.$emit('cancelFPrintFp')
    },
    printFp() {
      this.$emit('printFp')
    },
    cancelFPrintFp() {
      this.$emit('cancelFPrintFp')
    },
  },
}
</script>

<style lang="less">
.box-main-layout {
  display: flex;
  display: -webkit-flex;
  /*display: -moz-box;*/
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.box-main-layout .box-m {
  width: 770px;
  height: 500px;
  display: block;
  position: relative;
  //   background: url('../../../../assets/images/bg-fp.png') no-repeat;
  background-size: 100% 100%;
}

.fpdr {
  display: block;
  position: absolute;
  top: 212px;
  left: 30px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fpfp {
  display: block;
  position: absolute;
  top: 41px;
  left: 196px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fpcx {
  display: block;
  position: absolute;
  top: 111px;
  left: 524px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fpth {
  display: block;
  position: absolute;
  top: 380px;
  left: 196px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fptk {
  display: block;
  position: absolute;
  top: 212px;
  left: 375px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.kccx {
  display: block;
  position: absolute;
  top: 212px;
  left: 196px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fpzf {
  display: block;
  position: absolute;
  top: 308px;
  left: 524px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.xxb {
  display: block;
  position: absolute;
  top: 308px;
  left: 658px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fpxf {
  display: block;
  position: absolute;
  top: 111px;
  left: 658px;
  width: 66px;
  height: 75px;
  background: #e1e1e1;
  border: 2px solid #8b8b8b;
}

.fpdr img,
.fpfp img,
.fpcx img,
.fpth img,
.fptk img,
.kccx img,
.fpzf img,
.xxb img,
.fpxf img {
  width: 100%;
}

.item-active:hover {
  border: 2px solid #0078d7;
}

.fptk-icon {
  margin-top: 10px;
  /* width: 100%; */
  margin-left: 22%;
  height: 20px;
  line-height: 20px;
}

.fptk-icon-child {
  justify-content: space-between;
  font-size: 13px;
  cursor: pointer;
}

.fptk-icon-child-img :focus {
  background: #ffffff;
}

.fptk-content {
  /*background: url("../../../assets/images/kp.png") no-repeat;*/
  height: 540px;
  padding: 1px;
  width: 803px;
}

.fptk-zp {
  //   background: url('../../../../assets/images/zp.png') no-repeat;
}

.fptk-pp {
  //   background: url('../../../../assets/images/kp.png') no-repeat;
}

.fptk-icon-child-img {
  /*width: 50px;*/
  /*height: 23px;*/
  margin-top: -3px;
}

.fptk-icon-child-img:hover {
  border: solid 1px #4677c1;
  background: #40a9ff61;
}

.kp-number {
  line-height: 30px;
  /*height: 30px;*/
  width: 165px;
  margin-left: 130px;
  margin-top: 30px;
}

.kp-number input,
.kp-number1 input {
  border: none;
  letter-spacing: 3px;
  font-size: 20px;
  font-family: '宋体';
  color: black;
  font-weight: bold;
  width: 200px;
}

.kp-area {
  /*width: 100px;*/
  height: 40px;
  line-height: 40px;
  color: #267abd;
  margin-top: 19px;
  margin-left: -15px;
}

.kp-area input {
  width: 80px;
  font-size: 20px;
  font-family: '宋体';
  font-weight: bold;
  text-align: right;
  border: none;
}

.kp-number1 {
  margin-top: 33px;
  margin-left: 192px;
}

.kp-date {
  margin-top: 14px;
  color: black;
  font-size: 12px;
  margin-left: 611px;
  font-family: '宋体';
}

.zt {
  font-family: '宋体';
  color: #000000;
}

.kp-purchaser {
  width: 798px;
  height: 90px;
  display: flex;
}

.purchaser-left {
}

.purchaser-left-child {
  width: 260px;
  height: 15px;
  line-height: 15px;
  margin-left: 181px;
  display: flex;
}

.purchaser-left-child input {
  border: none;
  width: 100%;
  height: 100%;
  font-size: 12px;
  padding-left: 4px;
}

.purchaser-right {
  margin-left: 28px;
  margin-top: 14px;
  border: none;
  width: 314px;
  height: 93px;
}

.kp-vouch-qd {
  border: none;
  width: 100%;
  height: 100%;
  font-family: '宋体';
}

.kp-vouch {
  border: none;
  /* margin-top: 10px; */
  width: 79%;
  height: 19%;
  margin-left: 10%;
  font-family: '宋体';
}

.kp-vouch-header,
.kp-vouch-content {
  display: flex;
  border: 1px solid #1890ff;
}

.kp-vouch-content {
  border-top: none;
}

.kp-vouch-content:focus,
.hz-vouch-cent:focus {
  background: #5980a0;
}
.hz-vouch-cent div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kp-vouch-header > div {
  text-align: center;
  color: #000000;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  border-left: 1px solid #1890ff;
}

.kp-vouch-header > div:first-child,
.kp-vouch-content > div:first-child {
  border-left: none;
}

.kp-vouch-content > div {
  text-align: left;
  color: #000000;
  height: 15px;
  line-height: 15px;
  font-size: 13px;
  border-left: 1px solid #1890ff;
}

.kp-vouch-content > div:first-child {
  border-left: none;
}

.kp-vouch-content > div > input,
.kp-vouch-content-ck > input {
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  padding-left: 5px;
  -moz-appearance: textfield;
}

.select1 {
  background: #dce6f0;
}

.select2 {
  background: #f0faff;
}

.kp-money {
  display: flex;
  width: 25%;
  height: 20px;
  line-height: 27px;
  margin-left: 63%;
}

.kp-money > div,
.kp-zn > div {
  height: 100%;
  font-size: 12px;
}

.kp-money-left {
  width: 200px;
}

.kp-zn {
  width: 600px;
  height: 25px;
  line-height: 29px;
  display: flex;
  margin-left: 32%;
  /* margin-top: 5px; */
}

.kp-zn-left {
  width: 370px;
}

.kp-zn-right {
  width: 220px;
  margin-left: -5%;
  /*margin-top: -2px;*/
}

.zt-size {
  font-size: 12px;
}

.kp-saler {
  width: 660px;
  height: 100px;
  display: flex;
  margin-left: 22.7%;
}

.kp-saler-left,
.kp-saler-right {
  height: 100%;
}

.kp-saler-left {
  width: 310px;
}

.kp-saler-left-content {
  height: 20px;
  width: 79%;
  border: none;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* padding-left: 2px; */
}

.kp-saler-left-content > input {
  height: 20px;
  line-height: 20px;
  width: 95%;
  border: none;
  background-color: transparent;
}

.kp-saler-right {
  margin-left: -24px;
  margin-top: 4px;
}

.kp-footer {
  display: flex;
  /*margin-top: 16px;*/
  /*margin-left: 161px;*/
  width: 550px;
}

.kp-footer > div > input {
  border: none;
  height: 20px;
  line-height: 20px;
  background-color: transparent;
}

.kp-footer-center {
  /*margin-left: 62px;*/
  margin-left: 10%;
  width: 17%;
  height: 17px;
  margin-top: -0.5%;
}

.kp-footer-right {
  margin-top: -1.2%;
  width: 25%;
  height: 17px;
  margin-left: 10%;
}

.kp-vouch-content > div > input:focus {
  background: #7d96b9;
}

.purchaser-left-child {
  display: flex;
}

.purchaser-left-child > div {
  justify-content: space-between;
}

.kp-daoru {
  width: 150px;
  background: #ffffff;
  border: 1px solid;
  top: 66px;
}

.daoru-hover,
.kehu-hover {
  border: 1px solid #000000;
  background: #ffffff;
  border-bottom: none;
  z-index: 1;
  position: relative;
}

.kp-daoru-child {
  display: flex;
  height: 22px;
  line-height: 22px;
  width: 100%;
}

.kp-daoru-child:hover {
  background: #b5d7f3;
  border: 1px solid #1890ff;
  z-index: 10;
}

/*.kp-daoru-child > div:first-child {*/
/*background: #eeeeee;*/
/*}*/
.msg-content {
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  color: #000000;
  font-size: 13px;
}

.kp-daoru-child > div:last-child {
  padding-left: 20px;
}

.kp-vouch-content-hover {
  background: #ffffff;
}

.grfp-header {
  display: flex;
  height: 25px;
  line-height: 25px;
  width: 92%;
  background: #1487c6;
  border: 1px solid #cccabb;
  margin-left: 3%;
}

.grfp-content {
  display: flex;
  height: 25px;
  width: 92%;
  margin-left: 3%;
  background: #ffffff;
}

.grfp-f > div:focus {
  background: #6a88a5 !important;
}

.grfp-content:hover {
  background: #6a88a7 !important;
}

.grfp-header-child {
  height: 100%;
  padding-left: 3px;
  color: #ffffff;
}

.grfp-title {
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 20px;
  font-family: 宋体;
  color: #000000;
}

.grfp-content-child {
  padding-left: 3px;
  height: 25px;
  line-height: 25px;
  border-right: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
}

.fptk-fl {
  width: 200px;
  position: absolute;
  top: 52%;
  left: 39%;
}

.fptk-fl > div {
  width: 100%;
  height: 25px;
  line-height: 25px;
  background: #ffffff;
  border: 1px solid #000000;
  padding-left: 25px;
}

.fptk-fl > div:last-child {
  border-top: none;
}

.fptk-fl > div:hover {
  background: #9bc7eb;
}

.gd-img {
  display: flex;
  margin-top: 10px;
  margin-left: 450px;
}

/*.gd-img > div > img {*/
/*height: 22px;*/
/*width: 51px;*/
/*}*/

.gd-img > div > hover {
  background: #a8cbe9;
  border: 1px solid #0078d7;
}

.pt-center {
  display: flex;
  height: 25px;
  line-height: 25px;
  background: #1487c6;
  color: #ffffff;
  margin-left: -20px;
}

.pt-center > div,
.pt-conteht > div {
  text-align: center;
  border-right: 1px solid #c3c3c3;
  border-bottom: 1px solid #c3c3c3;
}

.pt-conteht {
  display: flex;
  height: 25px;
  line-height: 25px;
  background: #6a88a7;
  color: #ffffff;
  margin-left: -20px;
}

.flhmqr-child {
  width: 100%;
  text-align: center;
  height: 20px;
  line-height: 0px;
  font-family: 宋体;
  font-size: 17px;
}

.flhmqr-sun {
  display: flex;
  color: #000000;
  line-height: 28px;
  margin-left: 145px;
}

.flhmqr-sun > div:last-child {
  color: #f955d8;
  letter-spacing: 3px;
  font-weight: 500;
  font-family: 宋体;
}

.flxz {
  display: flex;
  width: 100%;
  height: 100%;
}

.flxz > div:first-child {
  width: 20%;
  height: 92%;
  border: 1px solid;
}

.flxz > div:last-child {
  width: 80%;
  height: 86%;
}

.right-body-main {
  width: 100%;
  height: 5%;
  border: none;
  padding-left: 5px;
  box-sizing: border-box;
}

.ngtree-sea {
  display: flex;
  height: 30px;
  line-height: 30px;
  background: #f8f8f8;
}

.ngtree-sea > div > input {
  height: 25px;
  line-height: 25px;
  border: 1px solid #000000;
  background: #f0faff;
}

.ngtree-sea > div :last-child {
  margin-left: 15px;
}

.good-flex {
  display: -webkit-flex;
  /*display: -moz-box;*/
  display: flex;
}

.good-align-center {
  align-items: center;
}

.good-flex-left {
  justify-content: flex-start;
}

.good-flex-left-reverse {
  justify-content: flex-start;
}

.bgzl-modal-max {
  transform: none !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
}

.taskModal {
  position: absolute;
  z-index: 99999;
  width: 810px;
  height: 610px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 5px;
  border: 1px solid blue;
  min-width: 810px;
}

.normal-tab1 {
  width: 150px;
  height: 45px;
  //   background-image: url(../../../../assets/images/business-title.png);
  background-repeat: no-repeat;
  background-position: left top;
}

.active-tab1 {
  width: 150px;
  height: 45px;
  background-position: right top;
}

.normal-tab2 {
  width: 150px;
  height: 45px;
  //   background-image: url(../../../../assets/images/business-title.png);
  background-repeat: no-repeat;
  background-position: left bottom;
}

.active-tab2 {
  width: 150px;
  height: 45px;
  /* background-image: url(../assets/images/business-title.png);
  background-repeat: no-repeat; */
  background-position: right bottom;
}

.tab-content {
  display: block;
  height: 270px;
  width: 100%;
  background: #253849;
  padding: 2px;
  overflow-y: auto;
  position: relative;
}

.tab-content .t-t-tile {
  font-size: 18px;
  color: #f8a036;
  font-weight: bold;
  padding-top: 5px;
  text-align: center;
}

.tab-content .t-describe {
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  line-height: 16px;
}

.tab-content .t-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 35px;
}

.tab-content .t-footer button {
  border-radius: 0;
  float: right;
  margin-right: 5px;
}

.t-button {
  border: none;
}

.bgzl-header {
  background: #ffffff;
  height: 35px;
  width: 100%;
  display: -webkit-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bgzl-header .bgzl-title {
  display: -webkit-box;
  display: flex;
}

.bgzl-header .bgzl-title img {
  display: block;
  width: 20px;
  height: 20px;
}

.bgzl-header .bgzl-title .title {
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
  padding-left: 10px;
}

.bgzl-header .btn-g {
  background: #ffffff;
  border: none;
  color: black;
}

.bgzl-modal-max {
  transform: none !important;
  /*top: 630px !important;*/
  /*left: -400px !important;*/
  width: 100% !important;
  height: 100% !important;
}

.ant-table-wrapper {
  zoom: 0.8;
}

.ant-table-thead > tr > th,
.ant-table-column-sort {
  background: #1587ca !important;
}

.gl-bg {
  background: #1587ca;
  color: #ffffff;
  font-family: '正楷';
  border: 1px solid #c3c3c3;
  border-right: none;
  cursor: pointer;
}

.gl-content {
  color: #000000;
}

.gl-content:focus {
  background: #7d96b9;
}

.gl-content > td {
  font-family: '正楷';
  border-right: 1px solid #e3e3e3;
}

.glcontent > td:focus {
  background-color: #0078d7;
}

.gl-bg {
  background: #1587ca;
  color: #ffffff;
  font-family: '正楷';
  border: 1px solid #c3c3c3;
  border-right: none;
  cursor: pointer;
}

.fp-search {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 6%;
  align-items: center;
}

.search-top-left {
  display: flex;
  justify-content: space-around;
  width: 550px;
}

.search-top-right {
  display: flex;
  justify-content: space-around;
}

.search-body {
  display: flex;
  width: 100%;
  height: 100%;
}

.good-check-header {
  background: #f0f0f0;
  height: 35px;
  display: flex;
}

.good-check-header > div {
  height: 35px;
  line-height: 35px;
  font-weight: 900;
  width: 75px;
  text-align: center;
  border: none;
}

.good-check-header-child:focus {
  background: #ffffff;
  color: blue;
  border: none;
}

.good-check-header-child:last-child:focus {
  border-left: 5px solid #0078d7 !important;
}

.gd-img {
  display: flex;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  background: #f3f3f3;
}

.gd-img > div {
  width: 60px;
  height: 30px;
}

.gd-center-first {
  display: flex;
  background: #ffffff;
}

.gd-center-first > div {
  display: flex;
}

.gd-sp > div {
  justify-content: space-between;
}

.gd-center-first-left,
.gd-center-first-right {
  width: 283px;
  height: 30px;
  line-height: 30px;
}

.gd-center-first-left-childleft,
.gd-center-first-right-childleft {
  width: 100px;
  text-align: right;
  border: none;
  margin-right: 10px;
}

.gd-sp > div > div {
  color: #000000;
  font-size: 13px;
  font-family: '黑体';
}

.gd-center-first-left-childright > input,
.gd-center-first-right-childright > input {
  width: 183px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #000000;
}

.gd-center-first-right-childright > select {
  width: 183px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #000000;
  background-color: transparent;
}

.gd-bg {
  background: #e1e1e1e1;
}

.gd-xs {
  cursor: pointer;
}

.qqqq {
  height: 25px;
  line-height: 25px;
  border: 1px solid #000000;
  width: 200px;
}

.gd-center-first-left-childright > select {
  width: 60px;
  height: 25px;
  line-height: 25px;
  background-color: transparent;
  border: none;
}

.gd-center-first-right-childright,
.gd-center-first-right-childright-child-2 {
  display: flex;
}

.gd-center-first-right-childright > div {
  justify-content: space-between;
}

.gd-center-first-left-childright {
  width: 200px;
  height: 25px;
  line-height: 25px;
}

.gd-center-first-right-childright {
  width: 201px;
}

.gd-center-first-right-childright-child-1 > select,
.gd-center-first-right-childright-child-2 > div > select {
  width: 60px;
  height: 25px;
  line-height: 25px;
  background-color: transparent;
}

.gd-img > div > img:hover {
  background: #a8cbe9;
  border: 1px solid #0078d7;
}

.zzz {
  margin-left: 24%;
  width: 21%;
  height: 18px;
  line-height: 18px;
  margin-top: -0.5%;
}

.fp-img {
  position: absolute;
  z-index: -1;
  width: 799px;
  height: 538px;
}

.qd-header {
  display: flex;
  height: 30px;
  line-height: 30px;
  margin-left: 25px;
  color: blue;
  font-size: '宋体';
  font-weight: 600;
}

.qd-header > div {
  display: flex;
  width: 150px;
  justify-content: space-between;
  border: none;
}

.qd-header > div:last-child {
  margin-left: 50px;
}

.hz-check-header {
  display: flex;
  justify-content: flex-end;
}

.hz-check-header > div {
  cursor: pointer;
}

.hz-vouch-head {
  display: flex;
  color: #ffffff;
  width: 500%;
  overflow: auto;
}

.hz-vouch-head > div {
  text-align: center;
  height: 30px;
  line-height: 30px;
  background: #1587ca;
  border: 1px solid #e3e3e3;
  border-left: none;
}

.hz-vouch-cent {
  height: 30px;
  line-height: 30px;
  /*border: 1px solid #e3e3e3;*/
  /*border-left: none;*/
  /*padding-left: 2px;*/
  width: 500%;
}

.hz-vouch-cent > div {
  border: 1px solid #e3e3e3;
  border-left: none;
  width: 100%;
}

.xxhz-content-input {
  display: flex;
  margin-left: 100px;
}

.xxhz-content {
  height: 280px;
  font-size: 15px;
  color: #000000;
  background: #f3f3f3;
}

.xxhz-content-header {
  height: 70px;
  line-height: 70px;
  width: 100%;
  text-align: center;
}

.xxhz-content-title {
  padding: 30px 58px;
  width: 100%;
}

.xxhz-content-input > div > div {
  margin-left: 10px;
}

.xxhz-content-input > div {
  height: 25px;
  line-height: 25px;
}

.xxhz-content-input > div:first-child {
  width: 100px;
  text-align: right;
}

.xxhz-content-input > div > input {
  width: 250px;
}

.hz-footer {
  height: 60px;
  line-height: 60px;
  margin-left: 310px;
}

.hz-footer > div > button {
  height: 40px;
  font-size: 16px;
  width: 80px;
}

.xx-hui {
  background: #e3e3e3;
}

.xx-bule {
  background: #1890ff;
}

.xxhz-content-three {
  /*width: 200px !important;*/
  height: 20px !important;
  line-height: 20px !important;
}

.xxhz-content-content-three {
  height: 224px;
  background: #ffffff;
  margin-top: 5px;
  width: 500px;
  overflow-y: scroll;
  border: 1px solid #000000;
  margin-left: 55px;
}

.xxhz-content-margin {
  margin-left: 0px !important;
}
.print-hide {
  display: none;
}

.print-kuang {
  border: 1px solid #8b8b8b;
  width: 355px;
  height: 70px;
  margin-left: 30px;
}

.print-shezhi {
  position: absolute;
  top: 81px;
  left: 63px;
  background: #e3e3e3;
  width: 113px;
  font-size: 16px;
}

.print-select {
  margin-top: 9px;
  background: #bfbfbf;
  width: 323px;
  height: 25px;
  line-height: 30px;
}

.print-tiaozhen {
  height: 100px;
  width: 245px;
  border: 1px solid #8b8b8b;
  margin-top: 16px;
  margin-left: 30px;
}

.print-xuanfu {
  position: absolute;
  top: 165px;
  font-size: 16px;
  margin-left: 56px;
  background: #e3e3e3;
  width: 73px;
}

.print-tiaozheng-flex {
  display: flex;
  width: 300px;
  line-height: 30px;
  height: 30px;
}

.print-tiaozheng-flex > div:first-child {
  width: 80px;
}

.print-tiaozheng-flex > div > input {
  width: 58px;
  height: 30px;
}

.print-tiaozheng-flex > div:last-child {
  margin-left: 25px;
}
.print-button {
  margin-top: 20px;
  margin-left: 128px;
}
.print-button-child {
  height: 35px;
  width: 70px;
  font-size: 10px;
  background: #1976d2;
}
</style>
